import { GET_PRICEOM_CONFIG_REQUEST, GET_PRICEOM_CONFIG_REQUEST_SUCCESS, GET_PRICEOM_CONFIG_REQUEST_FAILURE } from '../constants/priceom_config.constants';

export const getPriceOMConfigRequest = () => ({
    type: GET_PRICEOM_CONFIG_REQUEST,
});

export const getPriceOMConfigRequestSuccess = payload => ({
    type: GET_PRICEOM_CONFIG_REQUEST_SUCCESS, payload,
});

export const getPriceOMConfigRequestFailure = error => ({
    type: GET_PRICEOM_CONFIG_REQUEST_FAILURE, error,
});



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Price-o-matic_update/redux/actions/get_priceom_config.actions.js